export default "__VITE_ASSET__M1sQAxz___"